/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        27/06/2022 09:12
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import { applyFilters } from '@wordpress/hooks'

export default class FormComponent {
    constructor() {
        if ($('[data-lightpick-field="orchestra-input-date-start"]').length > 0) {
            import('@easepick/bundle' /* webpackChunkName: "scripts/easepick" */).then(
                ({ easepick, LockPlugin, RangePlugin, DateTime }) => {
                    const dateFormat = 'YYYY-MM-DD'

                    $('[data-lightpick-field="orchestra-input-date-start"]').each(function () {
                        const parentForm = this.closest('form')
                        new easepick.create({
                            element: this,
                            lang: 'fr-FR',
                            format: dateFormat,
                            css: [
                                'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
                                applyFilters('iris_core_easepick_stylesheet_url', ''),
                                `${IRISOrchestra.easepickCssUrl}`,
                            ],
                            plugins: [RangePlugin, LockPlugin],
                            RangePlugin: {
                                elementEnd: parentForm.querySelector(
                                    '[data-lightpick-field="orchestra-input-date-end"]',
                                ),
                                tooltip: true,
                            },
                            LockPlugin: {
                                minDate: new Date(),
                            },
                            setup(picker) {
                                picker.on('select', (e) => {
                                    const form = $(parentForm)
                                    const today = new DateTime()

                                    if (form.find('[data-id="dayName"]')) {
                                        let dateStart = e.detail.start.format(dateFormat)
                                        const dateTimeStart = new DateTime(dateStart)
                                        let dateEnd = e.detail.end.format(dateFormat)
                                        const dateTimeEnd = new DateTime(dateEnd)

                                        if (dateEnd === '') {
                                            dateEnd = dateStart
                                        }
                                        if (dateStart === '') {
                                            dateStart = dateEnd
                                        }
                                        if (dateEnd === '' && dateStart === '') {
                                            dateEnd = dateStart = today.format(dateFormat)
                                        }

                                        const diff = dateTimeEnd.diff(dateTimeStart, 'days')
                                        form.find('[data-id="durationName"]').val(`${diff},${diff}`)
                                        form.find('[data-id="monthName"]').val(
                                            e.detail.start.format('MM/YYYY'),
                                        )
                                        form.find('[data-id="dayName"]').val(
                                            e.detail.start.format('DD'),
                                        )
                                    }
                                })
                            },
                        })
                    })
                },
            )
        }

        if ($('[data-trigger="orchestra-dropdown"]').length > 0) {
            import('bootstrap/js/src/dropdown' /* webpackChunkName: "scripts/bs_dropdown" */).then(
                ({ default: Dropdown }) => {
                    import(
                        '../../styles/components/_bootstrap-dropdown.scss' /* webpackChunkName: "styles/bs_dropdown" */
                    ).then(() => {
                        const dropdownElementList = [].slice.call(
                            document.querySelectorAll('[data-trigger="orchestra-dropdown"]'),
                        )
                        const dropdownList = dropdownElementList.map(
                            (dropdownToggleEl) => new Dropdown(dropdownToggleEl),
                        )
                    })
                },
            )

            if ($('[name^="s_rooms_adult"]').length > 0) {
                $('[name^="s_rooms_adult"]').on('change', () => {
                    $('[data-trigger="orchestra-dropdown"]').html('')
                    $('[data-trigger="orchestra-dropdown"]').html(constructStringRooms())
                })
            }

            if ($('[name^="s_rooms_child"]').length > 0) {
                $('[name^="s_rooms_child"]').on('change', () => {
                    $('[data-trigger="orchestra-dropdown"]').html('')
                    $('[data-trigger="orchestra-dropdown"]').html(constructStringRooms())
                })
            }
        }

        if ($('[data-trigger="engine-booking-tabs"]').length > 0) {
            import(
                '@iris.interactive/handcook/public/scripts/components/tab/tab.component' /* webpackChunkName: "scripts/hc_tab" */
            ).then(({ HcTab }) => {
                $('[data-trigger="engine-booking-tabs"]').on('input', (e) => {
                    const val = $(e.currentTarget).val()
                    HcTab.show(`#${val}`)
                })
            })
        }

        if ($('[data-trigger="orchestra-add-sub-fields"]').length > 0) {
            $(document).on('change', '[data-trigger="orchestra-add-sub-fields"]', function () {
                const count = $(this).val()
                const subFielsMask = $(this)
                    .parent()
                    .siblings('[data-id="orchestra-sub-fields-mask"]')
                    .html()
                $(this)
                    .parent()
                    .parent()
                    .siblings('[data-id="orchestra-sub-fields-container"]')
                    .html('')
                let domSubFields = ''
                for (let i = 0; i < count; i++) {
                    const subFields = subFielsMask
                        .replaceAll('##child_number##', i + 1)
                        .replaceAll('##child_number_start_by_zero##', i)
                        .replaceAll('hidden', '')
                        .replaceAll('mask-', '')
                    domSubFields += subFields
                }
                $(this)
                    .parent()
                    .parent()
                    .siblings('[data-id="orchestra-sub-fields-container"]')
                    .html(domSubFields)
            })
        }

        if ($('[data-trigger="orchestra-form-submit"]').length > 0) {
            $(document).on('click', '[data-trigger="orchestra-form-submit"]', function (e) {
                e.preventDefault()
                let searchUrl = ''
                const form = $(this).parents('form')
                let total = 0
                if (form.find('[data-iris-orchestra-passenger-total]').length > 0) {
                    if (form.find('[name="adultsNumber"]').val() === '') {
                        form.find('[name="adultsNumber"]').val(2)
                    }

                    if (form.find('[name="childrenNumber"]').val() === '') {
                        form.find('[name="childrenNumber"]').val(0)
                    }

                    total = total + Number.parseInt(form.find('[name="adultsNumber"]').val())
                    total = total + Number.parseInt(form.find('[name="childrenNumber"]').val())

                    form.find('[data-iris-orchestra-passenger-total]').val(total === 0 ? 2 : total)
                }

                for (const element of [...form.get(0).elements]) {
                    if ($(element).attr('name') !== undefined && $(element).attr('name') !== '') {
                        const name = $(element).attr('name')
                        const val = $(element).val()
                        if (val !== '') {
                            if (name !== 'orchestraFormUrl') {
                                searchUrl += `&${name}=${val}`
                            } else {
                                searchUrl += val
                            }
                        }
                    }
                }

                searchUrl += '&s_rooms=1'

                window.open(searchUrl, '_blank')
            })
        }

        function constructStringRooms() {
            let numberChild = 0
            let numberAdult = 0
            let numberRooms = 1
            if ($('[name^="s_rooms_adult"]').length > 0) {
                numberRooms = $('[name^="s_rooms_adult"]').length
                $('[name^="s_rooms_adult"]').each(function () {
                    numberAdult = numberAdult + Number.parseInt($(this).val())
                })
            }

            if ($('[name^="s_rooms_child"][data-trigger="orchestra-add-sub-fields"]').length > 0) {
                $('[name^="s_rooms_child"][data-trigger="orchestra-add-sub-fields"]').each(
                    function () {
                        numberChild = numberChild + Number.parseInt($(this).val())
                    },
                )
            }

            return `${numberRooms} chambres, ${numberAdult} adultes${numberChild !== 0 ? ` et ${numberChild} enfants` : ''}`
        }
    }
}
